const DEFAULT_IMAGE = 'https://simplenexus.com/images/profile_sihlouette.png'
class NullProfile {
  constructor () {
    this.name = 'Please'
    this.last_name = 'wait...'
    this.borrower_web_content_setting_splash_header = 'Please wait...'
    this.borrower_web_content_setting_splash_subheader = 'Loading'
  }
}
export class NullServicer extends NullProfile {
  constructor () {
    super()
    this.state_lics = '[]'
    this.effective_company_nmls = 'Loading'
    this.profile_url = DEFAULT_IMAGE
  }
}
export class NullPartner extends NullProfile {
  constructor () {
    super()
    this.profile_img_url = DEFAULT_IMAGE
  }
}
